import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import {parseMessage} from '../../../../../lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';
import {TaskType} from '../../../../../constants/dataEnum';
import {getRangeRetractSpeed} from '../../../../../stores/selectors/configSelectors';

function PipettingItemRetractSpeed({task, onChange}) {
  const {type, retractSpeed} = task;
  let taskType = type;
  if (type !== TaskType.ASPIRATE && type !== TaskType.DISPENSE) {
    taskType = TaskType.ASPIRATE;
  }

  const rangeRetractSpeed = useSelector(getRangeRetractSpeed);

  const labelAspirate = parseMessage('protocolEditor.taskList.pipettingProfile.retractSpeedAspirate');
  const labelDispense = parseMessage('protocolEditor.taskList.pipettingProfile.retractSpeedDispense');
  const labelRetractSpeed = parseMessage('protocolEditor.taskList.pipettingProfile.retractSpeed');

  let label = labelRetractSpeed;
  if (type === TaskType.ASPIRATE) {
    label = labelAspirate;
  } else if (type === TaskType.DISPENSE) {
    label = labelDispense;
  }

  return (
    <PipettingProfileItemWrapper>
      {label}
      <PipettingProfileInputType.NumericTextBox
        value={retractSpeed}
        minValue={rangeRetractSpeed[taskType].minValue}
        maxValue={rangeRetractSpeed[taskType].maxValue}
        onChange={(value) => onChange(value, type)}
      />
      <PipettingProfileInputType.Unit.MillimeterPerSec />
    </PipettingProfileItemWrapper>
  );
}

PipettingItemRetractSpeed.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
};

export default PipettingItemRetractSpeed;
